<template>
  <div>
    <img v-if="mediaObject.type === 'image'" :src="mediaObject.file" />
    <video
      v-else-if="mediaObject.type === 'webm'"
      :src="mediaObject.file"
      playsinline
      autoplay
      muted
      loop
    ></video>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MediaObject",
  props: {
    mediaId: String
  },
  computed: {
    ...mapGetters({
      activeMediaObject: "ACTIVE_MEDIA_OBJECT"
    }),
    mediaObject() {
      return this.activeMediaObject(this.mediaId);
    }
  }
};
</script>

<style lang="scss" scoped>
img,
video {
  width: 100%;
}
</style>
